import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import React from 'react';

interface ResolutionChartProps {
  delivered: number;
  notDelivered: number;
  successRate: number;
}

export const ResolutionChart: React.FC<ResolutionChartProps> = ({
  delivered,
  notDelivered,
  successRate,
}) => {
  const chartData = [
    { name: 'Entregados', value: delivered, color: '#10b981' },
    { name: 'No Entregados', value: notDelivered, color: '#ef4444' },
  ];

  return (
    <div className='flex-1 min-h-[220px] relative animate-in fade-in zoom-in duration-700'>
      <ResponsiveContainer width='100%' height='100%'>
        <PieChart>
          <Pie
            data={chartData}
            cx='50%'
            cy='50%'
            innerRadius={75}
            outerRadius={100}
            paddingAngle={10}
            dataKey='value'
            strokeWidth={0}
            animationBegin={0}
            animationDuration={1500}
          >
            {chartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={entry.color}
                className='hover:opacity-80 transition-opacity'
              />
            ))}
          </Pie>
          <Tooltip
            contentStyle={{
              borderRadius: '16px',
              border: 'none',
              boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1)',
              fontWeight: '900',
              padding: '12px 16px',
            }}
          />
        </PieChart>
      </ResponsiveContainer>

      <div className='absolute inset-0 flex items-center justify-center pointer-events-none'>
        <div className='text-center'>
          <span className='block text-5xl font-black text-slate-900 tracking-tighter'>
            {successRate}%
          </span>
          <span className='text-[10px] font-black text-slate-400 uppercase tracking-[0.2em]'>
            Éxito Total
          </span>
        </div>
      </div>
    </div>
  );
};
